import React from "react";
import { Navigate } from "react-router-dom";

function PrivateRoute({ children }) {
  const userToken = localStorage.getItem("token");
  const auth = userToken;
  return auth ? children : <Navigate to="/" />;
}

export default PrivateRoute;
